exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".src-practitioner-components-global-add-button-styles__container {\n  height: 40px;\n  width: 40px;\n  background-color: var(--cps-color-primary-button-bg);\n  color: var(--cps-color-primary-button-text);\n  border-radius: 12px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.src-practitioner-components-global-add-button-styles__active {\n  background-color: var(--cps-color-secondary-button-bg);\n  color: var(--cps-color-secondary-button-text);\n}\n", ""]);

// exports
exports.locals = {
	"container": "src-practitioner-components-global-add-button-styles__container",
	"active": "src-practitioner-components-global-add-button-styles__active"
};